import AlertTypeSelectionPage from './AlertTypeSelection';

export default AlertTypeSelectionPage;
